/* eslint-disable @typescript-eslint/no-explicit-any */
import { Divider, Tooltip } from "@mui/material";
import { observer } from "mobx-react-lite";
import JDIPrice from "@/common-components-src/js/price/index";
import cn from "clsx";
import styles from "./mainOrderSummary.module.scss";
import  InfoIcon from "@/app/csr-src/assets/icons/TipIcon.svg";
import { useTranslation } from "react-i18next";
interface MainOrderSummaryTypes {
  orderDetails: any[];
  currencySymbol: string;
}

const MainOrderSummary = observer(({ orderDetails, currencySymbol }: MainOrderSummaryTypes) => {
  const { t } = useTranslation();
  // -------- constants --------------- //
  const DIVIDER_COLOR = "#F6F5FA";
  const FREE_LABEL = "FREE";
  const EMPTY = "";
  const NEGATIVE_OPERATOR = "-";
  const BLACK_COLOR = "#000";
  // ---------------------------------  //

  return (
    <div className={styles.orderSummaryContainer}>
      {orderDetails.map((item: any, index: number) => {
        return (
          <div key={index}>
            <div className={cn(styles.innerContainer, styles[item.containerSpacing])}>
              <div className={cn(styles.label, styles[item.labelClassName])}>
                {/* Title */}
                <span className={cn(styles.main, styles[item.labelSpacing])}>{item.label}</span>
                {/* Tooltip */}
                {item.iconFlag && (
                  <Tooltip
                    title={item.iconText}
                    arrow
                    placement="top"
                    slotProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: BLACK_COLOR,
                        },
                      },
                      arrow: {
                        sx: {
                          color: BLACK_COLOR,
                        },
                      },
                    }}
                  >
                    <div className={styles.icon}>
                      <InfoIcon />
                    </div>
                  </Tooltip>
                )}
                {/* Subtitle */}
                {item.subLabel && (
                  <span className={cn(styles.sub, styles[item.orderTotalSubLabel])}>
                    {item.subLabel}
                  </span>
                )}
              </div>
              <div className={styles.price}>
                {/* - Saved - */}
                {item.saved && item.saved.amount ? (
                  <div className={styles.savedContainer}>
                    <span className={styles.savedLabel}>{item.saved.label}</span>
                    <JDIPrice
                      symbol={currencySymbol}
                      price={item.saved.amount}
                      uiType={2}
                      containerStyle={item.saved.savePriceShowStyles}
                    />
                  </div>
                ) : null}
                {/* Normal Pricing */}
                <>
                  {/* Negative Value */}
                  <div className={styles.zf}>{item.zf ? NEGATIVE_OPERATOR : EMPTY}</div>

                  {/* SubPricing (handles Gray Strikethrough) */}
                  {item.showSubPricing && (
                    <JDIPrice
                      symbol={currencySymbol}
                      price={item.originalAmount}
                      uiType={2}
                      containerStyle={{ ...item.subPriceStyle }}
                      lineThrough={true}
                    />
                  )}

                  {/* Main Pricing or FREE label */}
                  {item.amount === FREE_LABEL ? (
                    <span className={styles.tag}>{t("checkout.paymentDetail.FREE")}</span>
                  ) : (
                    <JDIPrice
                      symbol={currencySymbol}
                      price={item.amount}
                      uiType={2}
                      containerStyle={{ ...item.priceStyle }}
                    />
                  )}
                </>
              </div>
            </div>
            {item.divider === true && <Divider sx={{ color: DIVIDER_COLOR }} />}
          </div>
        );
      })}
    </div>
  );
});

export default MainOrderSummary;
